<template>
    <div class="p-3">
        <div
            class="bg-light p-3 d-flex align-items-center justify-content-between rounded"
        >
            <div>Disable Inbound Calls</div>
            <b-form-checkbox v-model="disableInboundCalls" switch size="lg">
            </b-form-checkbox>
        </div>
        <div class="py-2">
            <font-awesome-icon icon="fa-light fa-check" class="text-success" />
            When turned off, creators will not be able to call you directly
        </div>
        <div class="py-2">
            <font-awesome-icon icon="fa-light fa-check" class="text-success" />
            You will still be able to call creators whenever you want
        </div>
        <div class="py-2">
            <font-awesome-icon icon="fa-light fa-check" class="text-success" />
            Your existing conversations and messages are not affected
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        disableInboundCalls: {
            get() {
                return this.onboardingUser.disableInboundCalls;
            },
            set(enable) {
                this.updateDisableInboundCalls(enable);
            },
        },

        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        updateDisableInboundCalls(enable) {
            this.api
                .post("/userFlag/disableInboundCalls", { enable })
                .then(() => {
                    this.$store.dispatch("onboarding/status");
                });
        },
    },
};
</script>
